import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, ShieldCheckIcon } from 'lucide-react';
export function PriceBlock() {
  const handleAddToCart = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Eco-S.O.S. Detox',
        content_type: 'product',
        value: 6.38,
        currency: 'USD'
      });
    }
  };
  return <section id="pricing" className="py-12 md:py-24 bg-sage-dark text-cream relative overflow-hidden" data-id="element-131">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-132"></div>

      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 relative z-10" data-id="element-133">
        <div className="bg-white rounded-3xl p-5 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-6 md:gap-12" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-1/2 flex justify-center" data-id="element-135">
            <img src="https://cdn.magicpatterns.com/uploads/6z2upji7HUiqywbwX9LxZn/heylloyd-image-1776034671398.png" alt="Eco-S.O.S. Detox eBook" className="w-full max-w-[200px] md:max-w-sm rounded-xl drop-shadow-xl" data-id="element-136" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full md:w-1/2 text-center md:text-left" data-id="element-137">
            <h2 className="text-2xl md:text-4xl font-serif text-dark mb-2 md:mb-4" data-id="element-138">
              Comienza tu transformación hoy
            </h2>
            <p className="text-dark/70 text-sm md:text-lg mb-4 md:mb-8" data-id="element-139">
              Obtén acceso inmediato al eBook completo para recuperar tu
              energía, eliminar la hinchazón y sentirte tú misma de nuevo.
            </p>

            <div className="mb-4 md:mb-8" data-id="element-140">
              <span className="text-xl md:text-2xl font-serif text-dark/40 line-through mr-2" data-id="element-141">
                $20
              </span>
              <span className="text-4xl md:text-5xl font-serif text-sage-dark font-bold" data-id="element-142">
                $6.38
              </span>
              <span className="text-dark/50 ml-2 text-sm" data-id="element-143">USD</span>
              <span className="ml-2 inline-block bg-red-100 text-red-600 text-xs md:text-sm font-bold px-2 md:px-3 py-1 rounded-full" data-id="element-144">
                -76% OFF
              </span>
            </div>

            <a href="https://esenciaactiva.it.com/cart/44026659700772:1" id="pricing-cta" onClick={handleAddToCart} className="w-full flex flex-col items-center justify-center px-6 md:px-10 py-4 md:py-5 bg-sage hover:bg-sage-dark text-white rounded-2xl font-medium transition-all duration-300 shadow-lg shadow-sage/30 group no-underline" data-id="element-145">
              <span className="flex items-center text-base md:text-xl mb-1" data-id="element-146">
                Obtener Eco-S.O.S. Detox Ahora
                <ArrowRight className="ml-2 w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-147" />
              </span>
              <span className="text-xs md:text-sm text-white/80 font-normal" data-id="element-148">
                Descarga instantánea, empieza hoy mismo.
              </span>
            </a>

            <div className="mt-4 flex items-center justify-center md:justify-start text-dark/50 text-xs md:text-sm" data-id="element-149">
              <Lock className="w-3.5 h-3.5 mr-1.5" data-id="element-150" />
              Pago 100% seguro y encriptado
            </div>

            <div className="mt-4 pt-4 border-t border-dark/10" data-id="element-151">
              <p className="text-dark/40 text-[10px] md:text-xs leading-relaxed text-center md:text-left" data-id="element-152">
                Al realizar tu compra, aceptas nuestros{' '}
                <a href="#" className="underline hover:text-dark/60 transition-colors" data-id="element-153">
                  Términos y Condiciones
                </a>{' '}
                y nuestra{' '}
                <a href="#" className="underline hover:text-dark/60 transition-colors" data-id="element-154">
                  Política de Privacidad
                </a>
                . Este es un producto digital. No se aceptan devoluciones una
                vez descargado el contenido.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}